import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const isDark = false;
  
  const navLinks = [
    { name: 'Pilot', path: '/pilot', icon: FiIcons.FiNavigation },
    { name: 'Unity', path: '/unity', icon: FiIcons.FiGift },
    { name: 'Scotty', path: '/scotty', icon: FiIcons.FiCpu },
    { name: 'Pollio', path: '/pollio', icon: FiIcons.FiBarChart2, isNew: true },
    { name: 'Memories', path: '/', icon: FiIcons.FiImage },
    { name: 'Avatars', path: '/avatars', icon: FiIcons.FiUsers },
    { name: 'Bifrost', path: '/bifrost', icon: FiIcons.FiZap },
    { name: 'Nima', path: '/nima', icon: FiIcons.FiActivity },
  ];

  return (
    <nav className={`fixed w-full z-50 backdrop-blur-md border-b transition-colors duration-300 ${isDark ? 'bg-slate-950/90 border-slate-800' : 'bg-white/90 border-gray-100'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between md:justify-center items-center h-20 md:gap-2 lg:gap-4">
          <div className="hidden md:flex items-center space-x-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link 
                  key={link.path} 
                  to={link.path} 
                  className={`relative flex items-center gap-2 px-2 py-2 rounded-full font-medium transition-all text-[9px] lg:text-[10px] uppercase tracking-wider group ${isActive ? 'text-indigo-600 bg-indigo-50/50' : 'text-gray-600 hover:text-indigo-600 hover:bg-gray-50'}`} 
                >
                  <SafeIcon icon={link.icon} className={`w-3 h-3 transition-transform group-hover:scale-110 ${isActive ? 'text-indigo-600' : 'text-gray-400 group-hover:text-indigo-500'}`} />
                  <span>{link.name}</span>
                  {link.isNew && (
                    <span className="absolute -top-1 -right-1 flex h-2 w-2">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-500"></span>
                    </span>
                  )}
                </Link>
              );
            })}
          </div>
          <div className="md:hidden flex items-center">
            <button onClick={() => setIsOpen(!isOpen)} className={`p-2 rounded-lg transition-colors ${isDark ? 'text-white hover:bg-slate-900' : 'text-gray-600 hover:bg-gray-50'}`} >
              <SafeIcon icon={isOpen ? FiIcons.FiX : FiIcons.FiMenu} className="h-6 w-6" />
            </button>
          </div>
        </div>
      </div>
      {isOpen && (
        <div className={`md:hidden absolute top-20 left-0 w-full border-b shadow-xl ${isDark ? 'bg-slate-950 border-slate-800' : 'bg-white border-gray-100'}`}>
          <div className="px-4 pt-2 pb-6 space-y-2">
            {navLinks.map((link) => (
              <Link key={link.path} to={link.path} onClick={() => setIsOpen(false)} className={`flex items-center justify-between px-4 py-3 rounded-xl text-base font-medium transition-colors ${location.pathname === link.path ? 'text-indigo-600 bg-indigo-50/50' : 'text-gray-600 hover:bg-gray-50'}`} >
                <div className="flex items-center gap-3">
                  <SafeIcon icon={link.icon} className="w-5 h-5 opacity-70" />
                  {link.name}
                </div>
                {link.isNew && <span className="px-2 py-0.5 bg-amber-100 text-amber-700 text-[10px] font-bold rounded-full uppercase">New</span>}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;